import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import team1 from "../../../assets/images/lp/team1.jpg";
import team2 from "../../../assets/images/lp/team2.jpg";
import team3 from "../../../assets/images/lp/team3.jpg";
 
const members = [
  {
    role: "プロジェクトマネージャー（PM）",
    desc: "業務整理・要件定義。現場の声を仕様に\n翻訳し、プロジェクト全体をリード。",
    image: team1,
  },
  {
    role: "SPFx／React専門エンジニア",
    desc: "画面の開発と外部システムとの連携。\n見やすさと表示速度の両立を担当。",
    image: team2,
  },
  {
    role: "Microsoft 365コンサルタント",
    desc: "セキュリティと権限の設計。\nCopilotなどの活用方法もあわせてご提案。",
    image: team3,
  },
];
 
const TeamSection = () => {
  return (
    <Box sx={{ backgroundColor: "#898989", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          TEAM
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, color: "#fff", fontSize: { xs: "26px", md: "50px" }, mb: 1.5 }}
        >
          開発チーム体制
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "#fff",
            mb: { xs: 4, md: 5 },
          }}
        >
          業務の整理、開発、Microsoft 365の運用設計。3つの役割でプロジェクトを進めます
        </Typography>
 
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
            gap: 3,
          }}
        >
          {members.map((member) => (
            <Paper
              key={member.role}
              elevation={0}
              sx={{
                borderRadius: "12px",
                overflow: "hidden",
                border: "2px solid #fff",
                backgroundColor: "transparent",
                p: 3,
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  height: 220,
                  backgroundColor: "#c9ccd1",
                  backgroundImage: member.image ? `url(${member.image})` : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <Box sx={{ pt: 2, pb: 1 }}>
                <Typography
                  sx={{ fontWeight: 700, fontSize: "16px", color: "#fff", mb: 1 }}
                >
                  {member.role}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.8)",
                    lineHeight: 1.8,
                    whiteSpace: { xs: "normal", sm: "pre-line" },
                  }}
                >
                  {member.desc}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
 
export default TeamSection;